import { __decorate } from "tslib";
import * as CONST from '../const';
import Reportable from '../decorators/reportable';
import Utils from '../utils';
import EventEmitter from 'events';
import UICommon from './common';
class UIPreview extends EventEmitter {
    owner;
    project;
    calculator;
    oldHeight = 0;
    constructor(owner, project, calculator) {
        super();
        this.owner = owner;
        this.project = project;
        this.calculator = calculator;
        project.on('imageChanged', () => { this.render(); });
        project.on('propertyChanged.baget', () => { this.render(); });
        project.on('propertyRemoved.baget', () => { this.render(); });
        project.on('propertyChanged.paspartu', () => { this.render(); });
        project.on('propertyRemoved.paspartu', () => { this.render(); });
        project.on('widthChanged', () => { this.render(); });
        project.on('heightChanged', () => { this.render(); });
    }
    render(inRoom = true, containerID = 'closeup') {
        if (inRoom) {
            this.renderInRoom();
        }
        else {
            this.renderCloseup(containerID);
        }
    }
    renderCloseup(containerID = 'closeup') {
        let sizeAndPos = this.getPictureSizeAndPosWithoutRoom(containerID);
        let cont = this.owner.getQuery().one('.calc_preview_frame', containerID);
        if (cont) {
            UICommon.updateStyle(cont, sizeAndPos);
        }
        this.renderBaget();
        let front = this.getContainerElement(false).querySelector('.calc_preview_middleRow .calc_preview_center_image'), image = this.project.getImage();
        if (front) {
            if (image) {
                UICommon.updateStyle(front, new Map([['background-image', `url(${image})`]]));
            }
            else {
                UICommon.updateStyle(front, new Map([['background-image', `url(${CONST.DEFAULT_IMAGE})`]]));
            }
        }
    }
    getContainerForInRoomRender() {
        let el = this.owner.getQuery().one('.calc_preview_in_room');
        if (el) {
            return el;
        }
        throw new Error('No HTMLElement for in room rendering of preview');
    }
    fixInRoomBackground() {
        if (this.isOptionsScrollNeeded()) {
            let backEl = this.owner.getQuery().one('img.back');
            if (backEl) {
                let imgBlockHeight = backEl.naturalHeight;
                if (imgBlockHeight > 100) {
                    Array.from(this.owner.getQuery().all('.scrollBlock', '')).
                        forEach(el => el.style.height = imgBlockHeight + 'px');
                }
                else {
                    Array.from(this.owner.getQuery().all('.scrollBlock', ''))
                        .forEach(el => el.style.height = 'auto');
                    setTimeout(() => {
                        let t = backEl.naturalHeight;
                        if (t > 100) {
                            Array.from(this.owner.getQuery().all('.scrollBlock', '')).forEach(el => el.style.height = t + 'px');
                        }
                    }, 1000);
                }
            }
        }
    }
    isOptionsScrollNeeded() {
        return !this.owner.isInOverlay() && !Utils.isMobile();
    }
    renderInRoom() {
        let sizeAndPos = this.getPreviewSizeAndPos(true);
        let cont = this.getContainerForInRoomRender();
        UICommon.updateStyle(cont, sizeAndPos);
        this.fixInRoomBackground();
        this.renderBaget();
        setTimeout(() => {
            let front = this.owner.getQuery().one('.calc_preview_middleRow .calc_preview_center_image'), image = this.project.getImage();
            if (front) {
                let styleMap = new Map([
                    ['background-position', 'center']
                ]);
                if (this.calculator.formatPreservingRequired()) {
                    styleMap.set('background-size', 'contain');
                }
                else {
                    styleMap.set('background-size', 'cover');
                }
                if (image) {
                    styleMap.set('background-image', `url(${image})`);
                }
                else {
                    styleMap.set('background-image', `url(${CONST.DEFAULT_IMAGE})`);
                }
                UICommon.updateStyle(front, styleMap);
            }
            else {
                setTimeout(this.renderInRoom.bind(this), 300);
            }
        }, 200);
    }
    getPreviewSizeAndPos(inRoom = true) {
        //return this.getPictureSizeAndPosWithRoom();
        if (inRoom) {
            return this.getPictureSizeAndPosWithRoom();
        }
        else {
            return this.getPictureSizeAndPosWithoutRoom('closeup');
        }
    }
    getContainerElement(inRoom = true) {
        let el;
        if (inRoom) {
            el = this.owner.getQuery().container('main');
        }
        else {
            el = this.owner.getQuery().container('closeup');
        }
        if (el) {
            return el;
        }
        throw new Error('No preview container element');
    }
    getPictureSizeAndPosWithRoom() {
        let room = this.owner.getQuery().one('.calc-preview-img');
        if (this.oldHeight && this.oldHeight > 10) {
            room.style.height = this.oldHeight + 'px';
        }
        let compositeSize = this.project.geometry.getCompositeSize(), w_percent = (compositeSize.width * this.getMagnification() / 627 * 100), h_percent = (compositeSize.height * this.getMagnification() / 397 * 100), left = ((62 - w_percent) / this.getMagnification()), top = ((68 - h_percent) / this.getMagnification()), posAndSize = new Map([
            ['width', w_percent + '%'],
            ['height', h_percent + '%'],
            ['right', left + '%'],
            ['top', top + '%']
        ]);
        this.owner.getQuery().findAndUpdateStyle('.calc-preview-img .back', new Map([['display', 'block']]));
        return posAndSize;
    }
    getPictureSizeAndPosWithoutRoom(type = 'closeup') {
        let room = this.owner.getQuery().one('.calc-preview-img', type), preRoomCont = this.owner.getQuery().one('.calc-preview', type), roomCont = preRoomCont && preRoomCont.parentNode;
        if (!preRoomCont) {
            throw new Error('no rendered content element');
        }
        if (!room) {
            throw new Error('no rendered room element');
        }
        if (roomCont) {
            UICommon.updateStyle(roomCont, new Map([
                ['width', '100%'],
                ['height', '100%'],
                ['margin', 'auto auto'],
            ]));
        }
        else {
            throw new Error('no available field element');
        }
        let compositeSize = this.project.geometry.getCompositeSize(), ratio = compositeSize.width / compositeSize.height, w_percent, h_percent, goodSize = Math.min(roomCont.clientWidth, roomCont.clientHeight), width = goodSize, height = goodSize;
        let sizes = {
            outer: this.project.geometry.getCompositeSize(),
            inner: this.project.geometry.getInnerCompositeSize(),
            baget: this.project.geometry.getBagetWidth(),
            paspartu: this.project.geometry.getPaspartuWidth(),
            canvas: this.project.getSize(),
        };
        console.log('composite outer size', sizes.outer, sizes.outer.width / sizes.outer.height);
        console.log('composite inner size', sizes.inner, sizes.inner.width / sizes.inner.height);
        console.log('composite baget size', sizes.baget);
        console.log('composite paspartu size', sizes.paspartu);
        console.log('composite canvas size', sizes.canvas, sizes.canvas.width / sizes.canvas.height);
        let roomStyleFix = new Map();
        roomStyleFix.set('width', width + 'px');
        roomStyleFix.set('height', height + 'px');
        roomStyleFix.set('margin', 'auto auto');
        UICommon.updateStyle(room, roomStyleFix);
        if (ratio > 1) {
            w_percent = 100;
            h_percent = 100 / ratio;
        }
        else {
            w_percent = 100 * ratio;
            h_percent = 100;
        }
        console.log(w_percent, h_percent);
        let preRoomStyleFix = new Map();
        preRoomStyleFix.set('width', width + 'px');
        preRoomStyleFix.set('height', height + 'px');
        preRoomStyleFix.set('margin', 'auto');
        preRoomStyleFix.set('float', 'none');
        UICommon.updateStyle(preRoomCont, preRoomStyleFix);
        let left = (100 - w_percent) / 2, top = (100 - h_percent) / 2, posAndSize = new Map([
            ['width', w_percent + '%'],
            ['height', h_percent + '%'],
            ['left', left + '%'],
            ['top', top + '%']
        ]);
        return posAndSize;
    }
    async renderBaget() {
        let bagetWidth = this.project.geometry.getBagetWidthInPercents(), canvasSize = this.project.geometry.getCanvasSizeInPercents(), bagetHeight = this.project.geometry.getBagetHeightInPercents(), bagetData = this.project.geometry.getBagetData();
        let middleRowHeight = 100 - (bagetHeight * 2);
        this.owner.getQuery().findAllAndUpdateStyle('.calc_preview_topRow', new Map([['height', `${bagetHeight}%`]]), '');
        this.owner.getQuery().findAllAndUpdateStyle('.calc_preview_middleRow', new Map([['height', `${middleRowHeight}%`]]), '');
        this.owner.getQuery().findAllAndUpdateStyle('.calc_preview_bottomRow', new Map([['height', `${bagetHeight}%`]]), '');
        this.owner.getQuery().findAllAndUpdateStyle('.bagetCorner', new Map([
            ['height', '100%'],
            ['width', bagetWidth + '%'],
            ['background-size', '100% 100%']
        ]), '');
        this.owner.getQuery().findAllAndUpdateStyle('.bagetVertical:not(.calc_preview_center)', new Map([
            ['height', '100%'],
            ['width', bagetWidth + '%'],
            ['background-position', '0px 0px'],
            ['background-repeat', 'repeat'],
            ['background-size', '100% auto']
        ]), '');
        this.updateCenterSize();
        UICommon.findAllAndUpdateStyle('.bagetHorizontal', new Map([
            ['height', '100%'],
            ['width', (canvasSize.width - 0.2).toString() + '%'],
        ]), '');
        await this.updateBagetImages(bagetData, bagetWidth);
    }
    calcMarginInPercents(sideA, sideB, whole) {
        let inner = whole - (sideA + sideB);
        return {
            a: sideA / inner * 100,
            b: sideB / inner * 100,
        };
    }
    getPaspartuInStyles() {
        let compSize = this.project.geometry.getCompositeSize();
        let innerCompSize = this.project.geometry.getInnerCompositeSize();
        let result = { left: 0, top: 0, right: 0, bottom: 0 };
        if (this.project.hasPaspartu()) {
            let paspartu = this.project.geometry.getPaspartuWidth();
            result = {
                bottom: (paspartu.bottom / innerCompSize.height) * 100,
                top: (paspartu.top / innerCompSize.height) * 100,
                //100% width = baget*2+paspartu.left+paspartu.right+canvas.height
                left: (paspartu.left / compSize.width) * 100,
                right: (paspartu.right / compSize.width) * 100,
            };
        }
        return result;
    }
    getElementMargin(side, elStyle) {
        let val = elStyle.getPropertyValue(`margin-${side}`);
        return parseFloat(val ? val.replace('px', '') : '0.0');
    }
    getElementOuterSize(el) {
        let centerSize = el.getBoundingClientRect();
        let result = {
            size: {
                width: centerSize.width,
                height: centerSize.height,
            },
            margin: {
                'top': 0,
                'left': 0,
                'right': 0,
                'bottom': 0,
            }
        };
        let centerStyle = window.getComputedStyle(el);
        for (let side of Object.keys(result.margin)) {
            result.margin[side] = this.getElementMargin(side, centerStyle);
        }
        ;
        let horizontalSum = result.margin.left + result.margin.right;
        let verticalSum = result.margin.top + result.margin.bottom;
        result.size.width += horizontalSum;
        result.size.height += verticalSum;
        return result;
    }
    updateCenterWithBaget() {
        let bagetWidth = this.project.geometry.getBagetWidthInPercents();
        this.updateCenter(bagetWidth);
    }
    updateCenterWithoutBaget() {
        this.updateCenter();
    }
    getInnerHeightInPercents() {
        let height = 100;
        if (this.project.hasPaspartu()) {
            let innerCompSize = this.project.geometry.getInnerCompositeSize();
            let paspartu = this.project.geometry.getPaspartuWidth();
            height = 100 - ((paspartu.bottom + paspartu.top) / innerCompSize.height * 100);
        }
        return height;
    }
    updateCenter(bagetWidth = 0.0) {
        let paspartuDeltas = this.getPaspartuInStyles();
        let margins = {
            top: paspartuDeltas.top,
            bottom: paspartuDeltas.bottom,
            left: paspartuDeltas.left,
            right: paspartuDeltas.right,
        };
        let canvasWidth = (100.0 - bagetWidth * 2);
        let canvasHeight = 100.0;
        if (this.project.isWithPaspartuOverflow()) {
            canvasWidth -= (paspartuDeltas.left + paspartuDeltas.right);
            canvasHeight = this.getInnerHeightInPercents();
        }
        let centerEls = this.owner.getQuery().all(`.calc_preview_center`, '');
        for (let centerEl of Array.from(centerEls)) {
            UICommon.updateStyle(centerEl, new Map([
                ['margin-right', `${margins.right}%`],
                ['margin-left', `${margins.left}%`],
                ['width', `${canvasWidth}%`],
                ['height', `${canvasHeight}%`],
            ]));
            let innerSize = this.getElementOuterSize(centerEl);
            let density = innerSize.size.width / this.project.geometry.getInnerCompositeSize().width;
            let paspartu = this.project.geometry.getPaspartuWidth();
            let topMargin = density * paspartu.top;
            let bottomMargin = density * paspartu.bottom;
            UICommon.updateStyle(centerEl, new Map([
                ['margin-top', `${topMargin}px`],
                ['margin-bottom', `${bottomMargin}px`],
            ]));
            let centerInnerEl = centerEl.querySelector('.calc_preview_center_image');
            if (centerInnerEl) {
                if (this.project.hasPaspartu()) {
                    centerInnerEl.classList.remove('without_paspartu');
                    let innerHeight = innerSize.size.height; // + topMargin + bottomMargin;
                    if (innerHeight < 10) {
                        setTimeout(() => this.updateCenter(bagetWidth), 200);
                        return;
                    }
                    UICommon.updateStyle(centerInnerEl, new Map([
                        ['left', `-${innerSize.margin.left}px`],
                        ['top', `-${topMargin}px`],
                        ['right', `-${innerSize.margin.right}px`],
                        ['bottom', `-${bottomMargin}px`],
                        ['width', `auto`],
                        ['height', `auto`],
                    ]));
                }
                else {
                    centerInnerEl.classList.add('without_paspartu');
                }
            }
        }
    }
    updateCenterSize() {
        this.owner.getQuery().findAllAndUpdateStyle('.calc_preview_center', new Map([['z-index', '0']]));
        /*this.owner.getQuery().findAndUpdateStyle('.calc_preview_center', new Map([['z-index', '0']]), 'closeup');
        this.owner.getQuery().findAndUpdateStyle('.calc_preview_center', new Map([['z-index', '0']]), 'baget');*/
        if (this.project.geometry.isBagetSet()) {
            this.updateCenterWithBaget();
        }
        else {
            this.updateCenterWithoutBaget();
        }
    }
    async updateBagetImages(bagetData, bagetWidth) {
        try {
            if (bagetData && bagetData.value.cornerFile && bagetData.value.sideFile) {
                let sideURL = UICommon.convertBagetURL(bagetData.value.sideOriginalFile);
                let sideURLStyle = 'url(' + sideURL + ')';
                let cornerURL = UICommon.convertBagetURL(bagetData.value.cornerOriginalFile);
                let cornerURLStyle = 'url(' + cornerURL + ')';
                this.owner.getQuery().findAllAndUpdateStyle('.calc_preview_left', new Map([['background-image', sideURLStyle]]), '');
                this.owner.getQuery().findAllAndUpdateStyle('.bagetCorner', new Map([['background-image', cornerURLStyle]]), '');
                if (!bagetData.topSide) {
                    bagetData.topSide = await UICommon.rotateImageReturnDataURL(sideURL, 90);
                }
                if (!bagetData.bottomSide) {
                    bagetData.bottomSide = await UICommon.rotateImageReturnDataURL(sideURL, -90);
                }
                if (!bagetData.rightSide) {
                    bagetData.rightSide = await UICommon.rotateImageReturnDataURL(sideURL, 180);
                }
                this.owner.getQuery().findAllAndUpdateStyle('.calc_preview_bottomRow', new Map([
                    ['background-image', 'url(' + bagetData.bottomSide + ')'],
                    ['background-position', `${bagetWidth}% 0px`],
                    ['background-repeat', 'repeat-x'],
                    ['background-size', 'auto 100%'],
                ]), '');
                this.owner.getQuery().findAllAndUpdateStyle('.calc_preview_topRow', new Map([
                    ['background-image', 'url(' + bagetData.topSide + ')'],
                    ['background-position', `${bagetWidth}% 0px`],
                    ['background-repeat', 'repeat-x'],
                    ['background-size', 'auto 100%'],
                ]), '');
                this.owner.getQuery().findAllAndUpdateStyle('.calc_preview_right', new Map([
                    ['background-image', 'url(' + bagetData.rightSide + ')'],
                    ['background-position', `${bagetWidth}% 0px`],
                    ['background-repeat', 'repeat-y'],
                    ['background-size', '100% auto'],
                    ['float', 'none'],
                    ['position', 'absolute'],
                    ['right', '0px']
                ]), '');
            }
        }
        catch (e) {
            throw e;
        }
    }
    closeupContains(el) {
        let elContainer = this.owner.getQuery().container('closeup');
        if (elContainer) {
            while (el && el.parentNode && (el.parentNode !== document.body)) {
                if (el.parentNode.id === elContainer.id) {
                    return true;
                }
                el = el.parentNode;
            }
        }
        return false;
    }
    getMagnification() {
        return CONST.MAGNIFICATION;
    }
}
__decorate([
    Reportable
], UIPreview.prototype, "render", null);
__decorate([
    Reportable
], UIPreview.prototype, "renderCloseup", null);
__decorate([
    Reportable
], UIPreview.prototype, "renderInRoom", null);
__decorate([
    Reportable
], UIPreview.prototype, "getContainerElement", null);
__decorate([
    Reportable
], UIPreview.prototype, "updateBagetImages", null);
export default UIPreview;
